<template>
  <div class="zlc-admin-shell">
    <LeftMenu></LeftMenu>
    <RightContent></RightContent>
  </div>
</template>
<script>
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import store from '@/store/';
import {delCookie, setCookie} from '@/utils/base.js';
export default {
  components:{LeftMenu, RightContent},
  data(){return {baseInfo:{shop_name:'',user:{},version:{},app_id:'',w7:{},qr_code:'',qr_icon:'',token:'',logo:''}};},
  provide(){return {baseInfo:this.baseInfo};},
  created(){
    if(this.$route.query.from==='admin' || localStorage.getItem('zlc_shop_ui_version') !== '20261010') {
      delCookie('baseInfo');
      localStorage.setItem('zlc_shop_ui_version', '20261010');
    }
    this.loadBaseInfo();
  },
  methods:{
    async loadBaseInfo(){
      try {
        const res = await store.dispatch('common/getBaseInfo');
        Object.assign(this.baseInfo, res || {});
        if(!this.baseInfo.user) this.baseInfo.user = {};
        if(!this.baseInfo.version) this.baseInfo.version = {};
        localStorage.setItem('baseInfo', JSON.stringify(this.baseInfo));
        if(res && res.token) setCookie('token',res.token);
      } catch(e) { console.warn('加载单位信息失败', e); }
    }
  }
};
</script>
<style scoped>
.zlc-admin-shell{height:100vh;min-width:980px;display:flex;background:#f2f6fc;overflow:hidden}
</style>



// WEBPACK FOOTER //
// src/views/layout/main.vue